import { ApiResult, request, safeRequest } from '@synergy/api';

import { ProductDetailAttributeApi } from '../attributes/api/product-detail-attributes-api';
import { ProductDetailFilesApi } from '../files/api/product-detail-files-api';
import { ProductDetailOverviewApi } from '../overview/api/product-detail-overview-api';
import { ProductDetailPricesApi } from '../prices/api/product-detail-prices-api';
import { ProductDetailVariantsApi } from '../variants/api/product-detail-variants-api';

export class ProductDetailApi {
    constructor(protected baseUrl: string) {
        this.overview = new ProductDetailOverviewApi(this.baseUrl);
        this.files = new ProductDetailFilesApi(this.baseUrl);
        this.attributes = new ProductDetailAttributeApi(this.baseUrl);
        this.prices = new ProductDetailPricesApi(this.baseUrl);
        this.variants = new ProductDetailVariantsApi(this.baseUrl);
    }

    public overview: ProductDetailOverviewApi;
    public files: ProductDetailFilesApi;
    public attributes: ProductDetailAttributeApi;
    public prices: ProductDetailPricesApi;
    public variants: ProductDetailVariantsApi;

    public activate(id: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/products/${id}/activate`),
            () => null
        );
    }

    public deactivate(id: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/products/${id}/deactivate`),
            () => null
        );
    }

    public delete(id: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/products/${id}`),
            () => null
        );
    }
}
